<template>
  <div>
    <NuxtLayout>
      <client-only>
        <NuxtLoadingIndicator :height="4" :color="colors.orange50" />
      </client-only>
      <NuxtPage />
    </NuxtLayout>
    <Auth />
    <CsBubble v-if="isCsBubbleShown" :has-unread-messages="hasUnreadMessages" @click="handleOpen" />
    <client-only>
      <v-overlay v-model="isFullPageLoadingShown" scrim="rgba(255, 255, 255, 0.7)" width="100%" height="100%">
        <loading color="orange50" class="wd-absolute wd-top-1/2 wd-left-1/2 wd-transform wd--translate-x-1/2 wd--translate-y-1/2" />
      </v-overlay>
    </client-only>
  </div>
</template>

<script lang="ts" setup>
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
import 'swiper/css/grid'
import 'swiper/css/mousewheel'
import '@/assets/sass/main.scss'
import { CUSTOM_COLORS } from './constants/theme'
import Auth from '@/components/dialog/auth.vue'
import { useGlobalStore } from '@/store-pinia/global'

const CsBubble = defineAsyncComponent(() => import('@/components/CsBubble.vue'))
const Loading = defineAsyncComponent(() => import('@/components/icons/loading.vue'))

const colors = CUSTOM_COLORS

const route = useRoute()
const globalStore = useGlobalStore()
const { isFullPageLoadingShown } = storeToRefs(globalStore)

const { isLocaleMessageLoading } = useLocaleMessages()
useSentryRegister()
const { isCsBubbleShown, hasUnreadMessages, initialCs, handleOpen } = useCustomerService()

const shouldSetupCs = computed(() => route.meta.shouldSetupCs ?? true)

onBeforeMount(() => {
  // for the $nuxt in 3rd party library. gtm ... etc.
  window.$nuxt = new Proxy(
    {},
    {
      get(target, prop: string) {
        const nuxtApp = useNuxtApp()
        const provider = nuxtApp[prop]
        return provider
      },
    }
  ) as any
})
onMounted(() => {
  if (shouldSetupCs.value) {
    initialCs()
  }
})

watch(isLocaleMessageLoading, newIsLocaleMessageLoading => {
  isFullPageLoadingShown.value = newIsLocaleMessageLoading
})
</script>
